import React, { FC } from 'react';

import { Button, ButtonIntent } from 'app/design-system/components/Button';
import { useTranslation } from 'app/lang';
import { getAndroidApk } from 'app/packages/brand/get-android-apk';

import { InstructionImage } from '../InstructionImage';

import dictionary from './AndroidInstruction.dictionary.json';

import styles from './AndroidInstruction.module.scss';

export const AndroidInstruction: FC = () => {
  const { t } = useTranslation();
  const apkLink = getAndroidApk();

  return (
    <div className={styles.root}>
      <div className={styles.instruction}>
        <ul className={styles.stepList}>
          <li>{t(dictionary.step1)}</li>
          <li>{t(dictionary.step2)}</li>
          <li>{t(dictionary.step3)}</li>
          <li>{t(dictionary.step4)}</li>
        </ul>
        <InstructionImage fileName="installation_completed" />
      </div>
      <Button component="a"
              data-ga-event="qr-downloadApk"
              href={apkLink}
              intent={ButtonIntent.CALL_TO_ACTION}
              download
              block >
        {t(dictionary.downloadButton)}
      </Button>
    </div>
  );
};
